<template>
    <div>
        <b-breadcrumb :items="items" />
        <div class="container-fluid" style="background-color: white">
            <br>
            <div class="row" style="margin: 10px;" >
                <div class="col-sm-6">
                    <span><b>ชื่อ</b> : {{driver.first_name}}</span>
                    <br/><br/>
                    <span><b>นามสกุล</b> : {{driver.last_name}}</span>
                    <br/><br/>
                    <span>
                    <b>เบอร์โทรศัพท์</b> :
                    <span>{{driver.phone}}</span>
                </span>
                </div>
                <div class="col-sm-6">
                    <span><b>ทะเบียนรถ</b> : {{driver.license_plate}}</span>
                    <br/><br/>
                    <span><b>ค่าประกัน</b> :
                    <template v-if="form.insurance_total">
                        {{form.insurance_total | currency }}
                    </template>
                </span>
                    <br/><br/>
                    <span><b>ค่าประกันสะสม</b> : {{driver.insurance_fee_total | currency }}</span>
                </div>
            </div>
            <div class="col text-right">
                <button type="button" class="btn btn-outline-danger" @click="showRemoveTransactionModal">
                    <icon name="pencil-alt"></icon>
                    เพิ่ม/ลบ เงินประกัน
                </button>
            </div>
            <div class="col-12 table-responsive">
                <table class="table table-bordered text-center">
                    <thead>
                    <tr>
                        <th scope="col">วัน/เดือน/ปี ที่จ่าย</th>
                        <th scope="col">จำนวน</th>
                        <th scope="col">จำนวนคงเหลือ</th>
                        <th scope="col">ผู้ชำระ</th>
                        <th scope="col">ผู้รับเงิน</th>
                        <th scope="col">หมายเหตุ</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="data in insuranceTable" :class="{'text-danger':data.amount < 0,'text-success':data.amount > 0}">
                        <td>{{data.date | moment("DD/MM/YYYY") }}</td>
                        <td>{{data.amount | currency }}</td>
                        <td>{{data.balance | currency }}</td>
                        <td>{{driver.name}}</td>
                        <td>{{data.recipient}}</td>
                        <td>{{data.reason}}</td>
                    </tr>
                    </tbody>
                </table>
                <br/>
                <div v-if="insuranceTable.length > 0">
                    <vue-pagination :pagination="dataPaginate"
                                    @paginate="getPage">
                    </vue-pagination>
                </div>
            </div>
            <b-modal hide-header hide-footer
                     ref="transaction">
                <div>
                    <h3 style="text-align: center">แก้ไขประกัน</h3>
                    <div class="row form-group">
                        <div class="col-5 text-right">เพิ่มประกันคนขับ (+)</div>
                        <div class="col-6">
                           <input type="number" class="form-control" v-model="edit_data.income"/>
                        </div>
                    </div>
                    <div class="row form-group">
                        <div class="col-5 text-right">ลบประกันคนขับ (-)</div>
                        <div class="col-6">
                            <masked-input mask="-11111"
                                          v-model="edit_data.remove"
                                          class="form-control"
                                          type="tel" />
                        </div>
                    </div>
                    <div class="row form-group">
                        <div class="col-5 text-right">เหตุผลการแก้ไข <span style="color: red">*</span></div>
                        <div class="col-6">
                            <textarea class="form-control"
                                      style="min-height: 100px"
                                      v-model="edit_data.reason"
                                      placeholder="แก้ไขรายการฝากเงินประกันวันที่ 01/01/2020"></textarea>
                        </div>
                    </div>
                    <div class="col text-center">
                        <button class="btn btn-success" type="button" @click="saveEditData">
                            <icon name="save" style="width: 25px"></icon>
                            บันทึก
                        </button>&nbsp;&nbsp;
                        <button class="btn btn-secondary" type="button" @click="hideRemoveTransactionModal">
                            <icon name="times" style="width: 25px"></icon>
                            ยกเลิก
                        </button>
                    </div>
                </div>
            </b-modal>
            <!--<pre class="alert alert-primary">{{ form }}</pre>-->
        </div>
    </div>
</template>

<script>
    import { mapState } from "vuex";
    import DeleteConfirmModal from "../../Utility/DeleteConfirmModal";
    import VuePagination from "../../Pagination";
    import MaskedInput from 'vue-masked-input'
    import DatePicker from 'vue2-datepicker'
    import moment from 'moment';
    export default {
        components: {
            VuePagination,
            DeleteConfirmModal,
            MaskedInput,
            DatePicker
        },
        name: "insurance-information",
        data(){
          return{
              edit_data :{
                 income : '',
                 remove : '',
                 reason : ''
              },
              changeFormat: {
                  stringify: (date) => {
                      let date_moment = moment(date).format('YYYY');
                      const year = parseInt(date_moment) + 543;
                      console.log(moment(date).format('DD/MM/'+year));
                      return date ? moment(date).format('DD/MM/'+year) : null
                  },
                  parse: (value) => {
                      return value ? moment(value, 'DD/MM/YYYY').subtract(543, 'y').toDate() : null
                  }
              },
              lang: {
                  days: ['อา', 'จ', 'อ', 'พ', 'พฤ', 'ศ', 'ส'],
                  months: ['มกราคม', 'กุมภาพันธ์', 'มีนาคม', 'เมษายน', 'พฤษภาคม', 'มิถุนายน', 'กรกฎาคม', 'สิงหาคม', 'กันยายน', 'ตุลาคม', 'พฤศจิกายน', 'ธันวาคม'],
                  pickers: ['ถัดไป 7 วัน', 'ถัดไป 30 วัน', 'ก่อนหน้า 7 วัน', 'ก่อนหน้า 30 วัน'],
                  placeholder: {
                      date: 'วว/ดด/ปปปป',
                  }
              },
              items: [
                  {
                      text: "บันทึกการจ่ายค่าประกัน",
                      to: { name: "insurance-fee" }
                  },
                  {
                      text: "เพิ่มเติม",
                      active: true
                  }
              ],
          }
        },
        created(){
            this.$store.dispatch("InsuranceFee/getInsuranceTotal");
        },
        computed:{
            ...mapState({
                driver :state=>{
                    return state.Driver.form;
                },
                form : state=>{
                    return state.InsuranceFee.form
                },
                insuranceTable : state=>{
                    return state.InsuranceFee.insurance_data
                },
                dataPaginate:state=>{
                    return state.InsuranceFee.dataPaginate
                },
                user:state=>{
                    return state.Auth.user
                },
            })
        },
        methods:{
            showRemoveTransactionModal(id){
                this.$refs.transaction.show();
            },
            hideRemoveTransactionModal(){
                this.$refs.transaction.hide();
            },
            saveEditData(){
                if(this.edit_data.income && this.edit_data.remove){
                    alert('กรุณาเลือกใส่จำนวนเงินอย่างใดอย่างหนึ่ง')
                }
                else if(!this.edit_data.income && !this.edit_data.remove){
                    alert('กรุณาเลือกใส่จำนวนเงินอย่างใดอย่างหนึ่ง')
                }
                else if(!this.edit_data.reason){
                    alert("กรุณาใส่เหตุผลในการแก้ไขจำนวนเงิน")
                }else{
                    let remove_insurance = 0;
                    if(this.edit_data.remove){
                        remove_insurance = parseFloat(this.edit_data.remove);
                    }
                    let data = {
                        driver_id : this.driver.id,
                        amount : this.edit_data.income ? this.edit_data.income : remove_insurance ? remove_insurance : 0,
                        date : moment().format("YYYY-MM-DD"),
                        status_id : 2,
                        recipient : this.user.name,
                        reason : this.edit_data.reason
                    };
                    this.$store.dispatch("InsuranceFee/save",data).then(res=>{
                        if(res){
                            this.hideRemoveTransactionModal();
                            alert("บันทึกสำเร็จ");
                            this.edit_data ={
                                income : '',
                                remove : '',
                                reason : ''
                            };
                            this.$store.dispatch("InsuranceFee/showInsurance",{
                                driver_id : this.driver.id,
                                page : 1,
                            }).then(()=>{
                                this.$store.dispatch('Driver/getDriverById',this.driver.id)
                            })
                        }else{
                            alert('ไม่สามารถบันทึกประกันได้ เนื่องจากมียอดประกันไม่ถูกต้อง');
                        }

                    }).catch(err=>{
                        alert("บันทึกไม่สำเร็จ");
                    });
                }
            },
            getPage(){
                this.$store.dispatch("InsuranceFee/showInsurance",{
                    driver_id : this.driver.id,
                    page : this.dataPaginate.current_page,
                })
            }
        }
    }
</script>

<style scoped>
    thead{
        background-color: lightgray;
        color: black;
    }
    tbody{
        background-color: white;
        color: black;
    }
</style>
